"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardPayment = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var constants_1 = require("../../constants");
var data_1 = require("../../data");
var utils_1 = require("../../utils");
var ui_1 = require("./ui");
exports.CardPayment = (0, core_1.withCustomerAndAccountIds)(function (_a) {
    var _b;
    var _c, _d, _e, _f, _g;
    var accountId = _a.accountId;
    var _h = (0, data_1.useCardPayment)(accountId), data = _h.data, loading = _h.loading;
    //following existing logic and tests component should render even if there is an error
    if (loading) {
        return null;
    }
    var lastBillablePeriod = data.billablePeriods &&
        data.billablePeriods.billingSummary &&
        'billablePeriods' in data.billablePeriods.billingSummary
        ? (_d = (0, utils_1.getLastCompletePeriod)((_c = data.billablePeriods.billingSummary) === null || _c === void 0 ? void 0 : _c.billablePeriods)) === null || _d === void 0 ? void 0 : _d.totalCharge
        : undefined;
    var balance = data.billing &&
        data.billing.billingSummary &&
        'latestPeriod' in data.billing.billingSummary
        ? (_e = data.billing) === null || _e === void 0 ? void 0 : _e.billingSummary.latestPeriod.data.closingBalance.pounds
        : undefined;
    var predictedFinalBalance = data.recommendedDirectDebit &&
        data.recommendedDirectDebit.predictedFinalBalance
        ? data.recommendedDirectDebit.predictedFinalBalance.amount
        : undefined;
    var calculationEndDate = data.recommendedDirectDebit &&
        data.recommendedDirectDebit.calculationEndDate
        ? data.recommendedDirectDebit.calculationEndDate
        : undefined;
    var lastBillableDate = data.billablePeriods &&
        data.billablePeriods.billingSummary &&
        'billablePeriods' in data.billablePeriods.billingSummary
        ? (_g = (0, utils_1.getLastCompletePeriod)((_f = data.billablePeriods.billingSummary) === null || _f === void 0 ? void 0 : _f.billablePeriods)) === null || _g === void 0 ? void 0 : _g.end
        : undefined;
    var isDebtRisk = !!data.recommendedDirectDebit &&
        (0, utils_1.getNegative)(constants_1.BALANCE_THRESHOLD_LARGE_POSITIVE) >
            Number(predictedFinalBalance);
    return (react_1.default.createElement(ui_tools_1.AnalyticsPage, { name: analytics_subjects_1.CARD_PAYMENT, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(ui_1.CardPaymentUI, { accountId: accountId, lastBillAmount: lastBillablePeriod, balance: balance, predictedFinalBalance: predictedFinalBalance, calculationEndDate: calculationEndDate, lastBillableDate: lastBillableDate, isDebtRisk: isDebtRisk })));
});
